import React, { Component } from 'react';
import './App.css';
import { connect } from 'react-redux';
import { loadInfo } from './actions';
import Nav from './Nav';
import Ertekeles from './Ertekeles';

class UserInfo extends Component {
  state = { ekod: '' };

  componentDidMount() {
    let { info, dispatch, user } = this.props;
    if (!info && user) {
      dispatch(loadInfo(user));
    }
  }

  ekodOnChange = (ev) => {
    this.setState({ ekod: ev.target.value });
  }

  ekodKuldes = () => {
    let { dispatch, user } = this.props;
    let u = { id: user.id, name: user.name, kulcskod: this.state.ekod };
    dispatch(loadInfo(u));
  }

  render() {
    let { loading, info, notfound, ellenorzes } = this.props;
    if (loading) {
      return (
        <div>
          <Nav />
          <main role="main" className="container bg-dark">
            Adatok betöltése...
          </main>
        </div>);
    }

    if (ellenorzes) {
      return (
        <div>
          <Nav />
          <main role="main" className="container bg-dark">
            {ellenorzes > 1 ? <div>Hibás kód, próbálkozz újra! Ha nem vagy biztos mi az ellenőrző kódod, akkor lépj kapcsolatba velünk.</div> :
              <div>Üdvözölünk az úttárs rendszerben!<br />Első bejelentkezéskor meg kell adni az ellenőrző kódót.</div>}
            <form className="form-inline mt-5" onSubmit={this.ekodKuldes}>
              <div className="form-group mb-2">
                <input className="form-control" type='text'
                  placeholder='Ellenőrző kód' value={this.state.ekod}
                  onChange={this.ekodOnChange} />
              </div>
              <button className="btn btn-primary mb-2" onClick={this.ekodKuldes}>Azonosítás</button>
            </form>
          </main>
        </div>);
    }

    if (notfound || !info) {
      return (
        <div>
          <Nav />
          <main role="main" className="container bg-dark">
            Nem tudtuk beazonosítani a facebook profilja alapján.<br />Kérjük hívja ügyfélszolgálatunkat.
          </main>
        </div>);
    }



    let { nev, honap, osszeg, szabadsag, ev, betoltve, optifleet, daf, egyeb, total, egyedi, egyenleg } = info;
    let utinfo = [];
    if (ev) {
      utinfo.push(<div key="1" className="info"><div className="label">Úttárs</div><div className="value">{ev} éve</div></div>);
      if (szabadsag) utinfo.push(<div key="2" className="info"><div className="label">Fizetés nélküli szabadság</div><div className="value">{szabadsag} nap</div></div>);
      utinfo.push(<div key="3" className="info"><div className="label">E havi prémium</div><div className="value">{parseInt(osszeg, 10)} EUR</div></div>);
      if(!egyedi){
        utinfo.push(<div key="5" className="info"><div className="label">Összesen</div><div className="value">{parseInt(total, 10)} EUR</div></div>);
      }
      if (ev < 5) utinfo.push(<div key="4" className="info"><div className="label">Következő évforduló</div><div className="value">{betoltve}</div></div>);
    }

    if(egyedi){
      utinfo.push(<div key="5" className="info"><div className="label">Egyenleg</div><div className="value">{parseInt(egyenleg, 10)} EUR</div></div>);
    }


    return (
      <div>
        <Nav />
        <main role="main" className="container">
          <h2>{nev}</h2>
          <h3>{honap}</h3>
          {utinfo}
          {
            optifleet ? <div className="info"><div className="label">Optifleet</div><div className="value">{optifleet} pont</div></div> : null
          }
          {
            daf ? <div className="info"><div className="label">DAF</div><div className="value">{daf} pont</div></div> : null
          }
          {
            egyeb ? <div className="info"><div className="egyeb mt-3">{egyeb}</div></div> : null
          }
          <Ertekeles />
        </main>
      </div>
    );
  }
}

export default connect(
  state => ({ loading: state.loading, user: state.user, info: state.userInfo, notfound: state.userNotFound, ellenorzes: state.ellenorzes }),
  dispatch => ({ dispatch })
)(UserInfo);



// WEBPACK FOOTER //
// ./src/UserInfo.js